import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import type { FunnelStep } from '@/lib/analyticsNormalizer';

interface FunnelVisualizationProps {
  steps: FunnelStep[];
}

export function FunnelVisualization({ steps = [] }: FunnelVisualizationProps) {
  if (steps.length === 0) {
    return (
      <Card>
        <CardHeader>
          <CardTitle>Conversion Funnel</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-muted-foreground text-center py-8">
            No traffic data yet.
          </p>
        </CardContent>
      </Card>
    );
  }

  const maxValue = steps[0].value || 1;

  return (
    <Card>
      <CardHeader>
        <CardTitle>Conversion Funnel</CardTitle>
      </CardHeader>
      <CardContent className="space-y-1">
        {steps.map((step, i) => {
          const widthPct = Math.max((step.value / maxValue) * 100, 8);
          const dropOff =
            i > 0 && steps[i - 1].value > 0
              ? Math.round(((steps[i - 1].value - step.value) / steps[i - 1].value) * 100)
              : null;

          return (
            <div key={step.label}>
              {dropOff !== null && (
                <div className="flex items-center gap-2 pl-2 py-0.5">
                  <div className="h-px w-4 bg-muted-foreground/30" />
                  <span
                    className={`text-[10px] font-medium ${
                      dropOff > 40 ? 'text-red-500' : 'text-muted-foreground'
                    }`}
                  >
                    -{dropOff}% drop-off
                  </span>
                </div>
              )}
              <div className="flex items-center gap-3">
                <span className="text-xs text-muted-foreground w-24 truncate text-right shrink-0">
                  {step.label}
                </span>
                <div className="flex-1 relative h-9">
                  <div
                    className="absolute inset-y-0 left-0 rounded-r-md bg-primary/80 transition-all duration-500"
                    style={{ width: `${widthPct}%` }}
                  />
                  <span className="absolute inset-y-0 left-2 flex items-center text-xs font-semibold text-primary-foreground z-10">
                    {step.value.toLocaleString()}
                  </span>
                </div>
              </div>
            </div>
          );
        })}
      </CardContent>
    </Card>
  );
}
